import "core-js/modules/es.array.push.js";
import { hasRole, isAdminNotConsultant, isHolding } from "@/js/http/auth.js";
export default {
  name: "AdminUserSubMenusLinks",
  props: {
    loggedUserData: {
      type: Object,
      required: true
    },
    searchCriterias: {
      type: Object,
      required: false
    },
    isExternal: {
      type: Boolean,
      required: false,
      default: false
    },
    forceTab: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      canManage: false,
      canManagePos: false,
      canManageSupplierPrices: false,
      canManageWarehouses: false,
      canManageUserSignUpLinks: false,
      selectedTab: null,
      tabs: {
        users: "users"
      }
    };
  },
  created: function created() {
    this.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
    this.canManageUserSignUpLinks = hasRole(process.env.VUE_APP_ROLES_MANAGE_USER_SIGN_UP_LINKS);
    if (this.canManageUserSignUpLinks) {
      this.tabs.signUpLink = "signUpLink";
    }
    this.selectedTab = this.$route.query.tab || this.tabs.users;
    if (this.forceTab) {
      this.selectedTab = this.forceTab;
    }
  },
  methods: {
    changeTab: function changeTab() {
      if (this.forceTab) {
        this.selectedTab = this.forceTab;
      }
      if (this.isExternal) {
        this.$router.push({
          name: "adminUserList",
          query: {
            tab: this.$route.query.tab
          },
          force: true
        }).catch(function () {});
      }
      if (this.$route.query.tab) {
        this.selectedTab = this.tabs[this.$route.query.tab];
        this.$emit("tabChanged", this.$route.query.tab);
      } else if (this.selectedTab) {
        this.selectedTab = this.tabs[this.selectedTab];
        this.$emit("tabChanged", this.selectedTab);
      }
      if (!this.selectedTab) {
        if (this.canManage) this.selectedTab = this.tabs.users;
      }
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isHolding: isHolding
  },
  watch: {
    $route: function $route(oldRoute, newRoute) {
      if (oldRoute.query.tab !== newRoute.query.tab) {
        this.changeTab();
      }
    }
  }
};